import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
import type React from 'react';
export type BlankLayoutProps = {
  children: React.ReactNode;
};
const BlankLayout = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 1
    };
    t2 = {
      opacity: 0
    };
    t3 = {
      opacity: 0
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children) {
    t4 = <motion.div animate={t1} exit={t2} initial={t3}><div data-testid="private-blank-layout">{children}</div></motion.div>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default BlankLayout;